import type { FooterNavigationItem, NavigationFooterItem, PartnerItem } from '~/utils/interface'
import { ModalCollection, SLUG_NEWS, INSTRUCTION_SLUGS } from '~/constants'
import { LOBBY_GAME_URLS } from '~/configs/page-url'
import { SLUG_CATEGORY_NEWS } from '~/resources/news'

const globImages: GlobImageI = import.meta.glob('~/assets/images/footer/*', {
  eager: true
})

const iconImgUrl = '/assets/images/footer'

export const getFooterMenus: () => NavigationFooterItem[] = () => {
  const config = useRuntimeConfig()
  return [
    {
      title: 'TIN TỨC',
      subMenus: [
        {
          subTitle: 'Lô đề Online',
          link: `/${SLUG_NEWS.PAGE}?cat=${SLUG_CATEGORY_NEWS.LO_DE_ONLINE}`
        },
        {
          subTitle: 'Soi kèo bóng đá',
          link: `/${SLUG_NEWS.PAGE}?cat=${SLUG_CATEGORY_NEWS.SOI_KEO}`
        },
        {
          subTitle: 'Tip bóng đá',
          link: `/${SLUG_NEWS.PAGE}?cat=${SLUG_CATEGORY_NEWS.TIP_FOOTBALL}`
        },
        {
          subTitle: 'Kinh nghiệm cá cược',
          link: `/${SLUG_NEWS.PAGE}?cat=${SLUG_CATEGORY_NEWS.BETTING_EXPERIENCE}`
        },
      ]
    },
    {
      title: 'THÔNG TIN',
      subMenus: [
        {
          subTitle: 'Về chúng tôi',
          link: `/${INSTRUCTION_SLUGS.ABOUT_US}`
        },
        {
          subTitle: 'Khuyến mãi',
          link: '/khuyen-mai'
        },
        {
          subTitle: 'Câu hỏi thường gặp',
          link: `/${INSTRUCTION_SLUGS.WHAT_IS_BONG88}`
        },
        {
          subTitle: 'Hướng dẫn',
          link: `/${INSTRUCTION_SLUGS.HOW_TO_DEPOSIT}`
        }
      ]
    },
    {
      title: 'TRANG CƯỢC',
      subMenus: [
        {
          subTitle: 'Cược thể thao trực tiếp',
          link: LOBBY_GAME_URLS.SPORTS
        },
        {
          subTitle: `Cược gián tiếp tại ${config.public.INDIRECT_BRAND_NAME}`,
          link: `/${INSTRUCTION_SLUGS.WHAT_IS_BONG88}`
        },
        {
          subTitle: `Cược gián tiếp tại ${config.public.INDIRECT_BRAND2_NAME}`,
          link: `/${INSTRUCTION_SLUGS.WHAT_IS_BONGK}`
        }
      ]
    }
  ]
}
export const getLogoPartners: () => PartnerItem[] = () => {
  const config = useRuntimeConfig()
  return [
    {
      title: 'Evolution',
      logo: getImageURL(globImages, 'evolution', iconImgUrl, 'png')
    },
    {
      title: 'Tech Play',
      logo: getImageURL(globImages, 'techplay', iconImgUrl, 'png')
    },
    {
      title: 'Spribe',
      logo: getImageURL(globImages, 'spribe', iconImgUrl, 'png')
    },
    {
      title: 'BTI',
      logo: getImageURL(globImages, 'bti', iconImgUrl, 'png')
    },
    {
      title: 'PG',
      logo: getImageURL(globImages, 'pg', iconImgUrl, 'png')
    },
    {
      title: 'Saba',
      logo: getImageURL(globImages, 'saba', iconImgUrl, 'png')
    },
    {
      title: 'In',
      logo: getImageURL(globImages, 'im', iconImgUrl, 'png')
    },
    {
      title: 'Game bài HitClub',
      logo: getImageURL(globImages, 'hitclub', iconImgUrl, 'webp'),
      link: config.public.GO88_URL
    },
    {
      title: 'Rik.Vip',
      logo: getImageURL(globImages, 'rikvip', iconImgUrl, 'webp')
    },
    {
      title: 'B52',
      logo: getImageURL(globImages, 'b52', iconImgUrl, 'webp')
    },
    {
      title: 'CQ9',
      logo: getImageURL(globImages, 'cq9', iconImgUrl, 'png')
    }
  ]
}
export const logoBanks: PartnerItem[] = [
  {
    title: 'vietcombank',
    logo: getImageURL(globImages, 'vietcombank', iconImgUrl, 'webp')
  },
  {
    title: 'saccombank',
    logo: getImageURL(globImages, 'sacombank', iconImgUrl, 'webp')
  },
  {
    title: 'vietinbank',
    logo: getImageURL(globImages, 'vietinbank', iconImgUrl, 'webp')
  },
  {
    title: 'techcombank',
    logo: getImageURL(globImages, 'techcombank', iconImgUrl, 'webp')
  },
  {
    title: 'bidvbank',
    logo: getImageURL(globImages, 'bidv', iconImgUrl, 'webp')
  },
  {
    title: 'dongabank',
    logo: getImageURL(globImages, 'dongabank', iconImgUrl, 'webp')
  },
  {
    title: 'acbbank',
    logo: getImageURL(globImages, 'acb', iconImgUrl, 'webp')
  },
  {
    title: 'vietcapitalbank',
    logo: getImageURL(globImages, 'vietcapitalbank', iconImgUrl, 'webp')
  },
  {
    title: 'eximbank',
    logo: getImageURL(globImages, 'eximbank', iconImgUrl, 'webp')
  },
  {
    title: 'vpbank',
    logo: getImageURL(globImages, 'vpbank', iconImgUrl, 'webp')
  },
  {
    title: 'SHB Bank',
    logo: getImageURL(globImages, 'shb', iconImgUrl, 'webp')
  },
  {
    title: 'pvcombank',
    logo: getImageURL(globImages, 'pvcombank', iconImgUrl, 'webp')
  },
  {
    title: 'NCB',
    logo: getImageURL(globImages, 'nationalcitizenbank', iconImgUrl, 'webp')
  },
  {
    title: 'NAM A BANK',
    logo: getImageURL(globImages, 'namabank', iconImgUrl, 'webp')
  },
  {
    title: 'MSB',
    logo: getImageURL(globImages, 'msb', iconImgUrl, 'webp')
  },
  {
    title: 'MB',
    logo: getImageURL(globImages, 'mb', iconImgUrl, 'webp')
  },
  {
    title: 'HDBank',
    logo: getImageURL(globImages, 'hdbank', iconImgUrl, 'webp')
  },
  {
    title: 'BAC A BANK',
    logo: getImageURL(globImages, 'bacabank', iconImgUrl, 'webp')
  },
  {
    title: 'PG BANK',
    logo: getImageURL(globImages, 'pgbank', iconImgUrl, 'webp')
  },
  {
    title: 'SeABank',
    logo: getImageURL(globImages, 'seabank', iconImgUrl, 'webp')
  },
  {
    title: 'VIB',
    logo: getImageURL(globImages, 'vib', iconImgUrl, 'webp')
  },
  {
    title: 'SAIGONBANK',
    logo: getImageURL(globImages, 'saigonbank', iconImgUrl, 'webp')
  },
  {
    title: 'ABBANK',
    logo: getImageURL(globImages, 'abbank', iconImgUrl, 'webp')
  },
  {
    title: 'PUBLIC BANK',
    logo: getImageURL(globImages, 'publicbank', iconImgUrl, 'webp')
  },
  {
    title: 'OCB',
    logo: getImageURL(globImages, 'ocb', iconImgUrl, 'webp')
  },
  {
    title: 'AGRIBANK',
    logo: getImageURL(globImages, 'agribank', iconImgUrl, 'webp')
  },
  {
    title: 'SCB',
    logo: getImageURL(globImages, 'scbbank', iconImgUrl, 'webp')
  },
  {
    title: 'VIETBANK',
    logo: getImageURL(globImages, 'vietbank', iconImgUrl, 'webp')
  },
  {
    title: 'BAOVIET',
    logo: getImageURL(globImages, 'baoviet', iconImgUrl, 'webp')
  },
  {
    title: 'Shinhan Bank',
    logo: getImageURL(globImages, 'shinhanbank', iconImgUrl, 'webp')
  },
  {
    title: 'standard chartered',
    logo: getImageURL(globImages, 'standardchartered', iconImgUrl, 'webp')
  },
]

export const navigationItemsResource: FooterNavigationItem[] = [
  {
    title: 'Trang Chủ',
    icon: 'icon-home-mobile',
    link: '/',
    loginRequired: false,
    isNewTab: false,
    isActive: false,
    routeActive: [
      LOBBY_GAME_URLS.ALL_GAME,
      LOBBY_GAME_URLS.HOME,
      LOBBY_GAME_URLS.SPORTS,
      LOBBY_GAME_URLS.CASINO,
      LOBBY_GAME_URLS.FISHING,
      LOBBY_GAME_URLS.SLOT,
      LOBBY_GAME_URLS.LODE,
      LOBBY_GAME_URLS.NO_HU,
      LOBBY_GAME_URLS.GAME_BAI,
      LOBBY_GAME_URLS.INGAME,
      LOBBY_GAME_URLS.INSTANT_GAMES,
      LOBBY_GAME_URLS.BATTLE_GAMES,
      LOBBY_GAME_URLS.LOTTERY,
      LOBBY_GAME_URLS.OTHERS
    ]
  },
  {
    title: 'Khuyến Mãi',
    icon: 'icon-gift',
    link: '/khuyen-mai',
    loginRequired: false,
    isNewTab: false,
    isActive: false,
    routeActive: '/khuyen-mai'
  },
  {
    title: 'Giao dịch',
    icon: 'icon-deposit-withdraw',
    iconType: 'webp',
    link: '',
    loginRequired: true,
    isNewTab: false,
    isActive: false,
    modalIdOpen: ModalCollection.MANAGE_ACCOUNT,
    routeActive: ''
  },
  {
    title: 'Tin Tức',
    icon: 'icon-news',
    link: '/tin-tuc',
    loginRequired: false,
    isNewTab: false,
    isActive: false,
    routeActive: '/tin-tuc'
  }
]
